// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  ApiKeyGoogleMaps: 'AIzaSyDqN_7pnskjQW8I4lsqNSEce4I9cR_pZ3o',  
  // Wompi
  //ApiPublicKeyWompi: 'pub_test_YLpCQ040Qg8y6eFCHyxPw9HZv7Fcw7rX',
   ApiPublicKeyWompi: 'pub_test_YLpCQ040Qg8y6eFCHyxPw9HZv7Fcw7rX',
  // ApiPrivateKeyWompi: 'pub_prod_PF1PdhVDaieDDzns5xc7KnNMnELCM94F'
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
